export enum AssetClassEnum {
  EQUITY = 'Equity',
  FIXED_INCOME = 'Fixed Income',
  INTERNATIONAL_EQUITY = 'International Equity',
  //Temporary set to 'Asset Allocation' to match with the value received from Dada graphql
  MULTI_ASSET = 'Asset Allocation',
}
